<label class="checkbox"
  ><input
    class="checkbox__input"
    type="checkbox"
    [checked]="checked"
    (change)="onChange($event)" />
  <ng-content></ng-content
></label>
